export const getTextMatching = (questions, testType) => {
  if (questions.length === 1) {
    // this condition is because if parent component update twice
    return [questions[0]];
  } else {
    // FIXME
    return [
      {
        info: questions[0].info,
        info_audio: questions[0].info_audio,
        que: questions,
        id: questions[0].id,
        resp_time: questions[0].resp_time,
        // 500000000000000000000000,
        test_id: questions[0].test_id,
        test_format: questions[0].test_format,
        score_count: questions[0].score_count,
        section_name: questions[0].section_name,
      },
    ];
  }
};
